// eslint-disable-next-line
import { action, makeObservable, observable } from "mobx";
import { rootContainer, TYPE } from "../../../services/container/root";
import PagedDataStore, { IFetchListArgs } from "../../../stores/abstract-paged-data-store";
import TransactionsService, { ITransaction } from "../../../services/api/transactions-service";
import { IReportable } from "../../../stores/types";
import { IOption } from "../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";

interface ITransactionReportFilter {
	filter_customer_id: string,
	filter_date: string,
	filter_type: string,
}

class TransactionsPagedListStore extends PagedDataStore<ITransaction> implements IReportable<ITransactionReportFilter> {
	@observable private _filter_date_range: string = '';
	@observable private _search_customer_id: string = '';
	@observable private _filter_action_ids: string = '';

	constructor() {
		super();
		makeObservable(this);
	}

	@action.bound
	getReportFilters() {
		return {
			filter_customer_id: this._search_customer_id,
			filter_date: this._filter_date_range,
			filter_type: this._filter_action_ids
		}
	}

	@action
	public setSearchCustomerId(value: string) {
		this._search_customer_id = value;
	}

	@action
	public setFilterDateRange(value: string) {
		this._filter_date_range = value;
	}

	public get searchCustomerId() {
		return this._search_customer_id;
	}

	@action
	public setFilterActionIds(value: string) {
		this._filter_action_ids = value;
	}

	public filterByActionOptions(): IOption[] {
		return [
			{ value: '', label: 'Any' },
			{ value: '1', label: 'Purchase' },
			{ value: '2,3,4', label: 'Refund' },
		];
	}

	public get filterActionIds() {
		return this._filter_action_ids;
	}

	protected get service(): TransactionsService {
		return rootContainer.get<TransactionsService>(TYPE.TransactionsService);
	}

	protected async fetchList(args: IFetchListArgs) {
		return await this.service.fetchList({
			...args,
			search_customer_id: this._search_customer_id,
			filter_action_ids: this._filter_action_ids,
			filter_date_range: this._filter_date_range,
		});
	}
}

export default new TransactionsPagedListStore();
